<template>
  <div class="main-layout">
    <AppHeader />
    <main class="main-content">
      <div class="content-container">
        <router-view />
      </div>
    </main>
    <AppFooter />
    <FeedbackButton v-if="userStore.isLoggedIn" />
  </div>
</template>

<script setup lang="ts">
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import FeedbackButton from '@/components/FeedbackButton.vue'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
</script>

<style scoped>
.main-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-secondary);
}

.main-content {
  flex: 1;
  padding: 84px var(--spacing-md) var(--spacing-md);
  transition: padding 0.3s ease;
}

.content-container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
}

/* 平板适配 */
@media (max-width: 1024px) {
  .main-content {
    padding: 80px var(--spacing-md) var(--spacing-md);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .main-content {
    padding: 72px 0 var(--spacing-lg);
  }

  .content-container {
    padding: 0;
  }
}

/* 超小屏幕 */
@media (max-width: 375px) {
  .main-content {
    padding: 68px 0 var(--spacing-md);
  }
}
</style>
